export default "__VITE_ASSET__D$BYXPf$__";